import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin, getUserRole } from 'utils/general';

// Action Types
export const GET_ALL_PROVIDER_INFORMATION_DETAILS =
  'GET_ALL_PROVIDER_INFORMATION_DETAILS';
export const GET_ALL_PROVIDER_INFORMATION_DETAILS_SUCCESS =
  'GET_ALL_PROVIDER_INFORMATION_DETAILS_SUCCESS';
export const GET_ALL_PROVIDER_INFORMATION_DETAILS_FAILURE =
  'GET_ALL_PROVIDER_INFORMATION_DETAILS_FAILURE';

// Action Creators
export const fetchGetAllProviderInformationDetails = () => ({
  type: GET_ALL_PROVIDER_INFORMATION_DETAILS,
});

export const fetchGetAllProviderInformationDetailsSuccess = (data) => ({
  type: GET_ALL_PROVIDER_INFORMATION_DETAILS_SUCCESS,
  payload: data,
});

export const fetchGetAllProviderInformationDetailsFailure = (error) => ({
  type: GET_ALL_PROVIDER_INFORMATION_DETAILS_FAILURE,
  payload: error,
});

const getRole = (userRole, data, external) => {
  switch (userRole) {
    case 'company-admin':
      return (
        url.getSpecialistDetailCompanyProviderAdmin +
        external?.id +
        `/?query=${data}`
      );
    case 'salon-admin':
      return (
        url.getSpecialistDetailCompanyProviderAdmin +
        external?.id +
        `/?query=${data}`
      );
    case 'branch-company':
      return (
        url.getSpecialistDetailCompanyProviderAdmin +
        external?.id +
        `/?query=${data}`
      );
    case 'specialist-admin':
      return (
        url.getSpecialistDetailCompanyProviderAdmin +
        external?.id +
        `/?query=${data}`
      );
    case 'super-admin':
      return (
        url.getAllProviderInformationDetailsSuperAdmin +
        external?.id +
        `/?query=${data}`
      );
  }
};
// Thunk Function
export const getAllProviderInformationDetailsCallAPI = (
  data,
  external = {}
) => {
  return async (dispatch) => {
    dispatch(fetchGetAllProviderInformationDetails(data, external));
    try {
      const userRole = getUserRole();
      const response = await getMethodWithToken(
        getRole(userRole, data, external)
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAllProviderInformationDetailsSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAllProviderInformationDetailsFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAllProviderInformationDetailsFailure(error.message));
    }
  };
};
